import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-11d8fe1e"), n = n(), _popScopeId(), n);
const _hoisted_1 = { key: 0 };
import { onMounted, ref } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'badge',
    props: ['content', 'hasGlimmer', 'isWhite', 'isAbsolute', 'arrowCursor', 'small'],
    setup(__props) {
        const { content, hasGlimmer, isWhite, isAbsolute, arrowCursor, small } = __props;
        const badgeClass = 'badge-' + Math.random().toString().substring(7);
        const isBadgeScrolledIntoView = ref(false);
        onMounted(() => {
            const badgeElement = document.querySelector('.' + badgeClass);
            const badgeObserver = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                    isBadgeScrolledIntoView.value = entry.isIntersecting;
                });
            }, { threshold: 1 });
            badgeObserver.observe(badgeElement);
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("span", {
                class: _normalizeClass(["badge", [badgeClass, { 'badge__glimmer': __props.hasGlimmer }, { 'badge__white': __props.isWhite }, { 'badge__absolute': __props.isAbsolute }, { 'badge__arrow': __props.arrowCursor }, { 'badge__small': __props.small }]]),
                style: _normalizeStyle([isBadgeScrolledIntoView.value ? { 'background-position': '-120% 0' } : { 'background-position': '' }])
            }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.content, (title, index) => {
                    return (_openBlock(), _createElementBlock("span", { key: index }, [
                        _createTextVNode(_toDisplayString(title) + " ", 1),
                        (index !== __props.content.length - 1)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_1, " / "))
                            : _createCommentVNode("", true)
                    ]));
                }), 128))
            ], 6));
        };
    }
});
